import React from 'react';
import { connect } from 'react-redux'
import Form from './Form';
import Input from '../elements/Input';
import Row from '../elements/Row';
import Readout from '../elements/Readout';
import PlainButton from '../elements/PlainButton';
import SelectorControl from '../controls/SelectorControl';


import ActionVal from '../containers/ActionVal';

import { dot } from '../../lib/obj';
import { financial, capitalize } from '../../lib/formats';
import { docForLoc, groupNameForType } from '../../lib/inventory-util';
import { listItems, setItemField, setItemAction } from '../../actions/InventoryActions';

import './Form.css';
import './TransferItemForm.scss';

class TransferItemForm extends Form {

  // Edit the given field
  editField(field, value) {
    // Handle to the set item field options
    let opts = {
      type:"transfers",
      id: dot(this.props.transferItem,"data.transferId"),
      childType: "items",
      childId: dot(this.props.transferItem,"data.itemId"),
      field:field,
      value:value
    };
    // Check if editing inline
    if (this.props.listIndex !== undefined) {
      opts.index = this.props.listIndex;
    }
    this.props.setItemField(opts);
  }

  onProductClick(evt, history) {
    let productId = dot(this.props.transferItem,"data.itemId");
    if (productId) {
      history.push(`/products/${productId}`);
    }
  }

  onDeleteClick(evt) {
    console.log("onDeleteClick");
    // Handle to the set item field options
    let opts = {
      type:"transfers",
      id: dot(this.props.transferItem,"data.transferId"),
      childType: "items",
      childId: dot(this.props.transferItem,"data.itemId"),
      action: "delete"
    };
    // Check if editing inline
    if (this.props.listIndex !== undefined) {
      opts.index = this.props.listIndex;
    }
    this.props.setItemAction(opts);
  }

  onUndoClick(evt) {
    // Handle to the set item field options
    let opts = {
      type:"transfers",
      id: dot(this.props.transferItem,"data.transferId"),
      childType: "items",
      childId: dot(this.props.transferItem,"data.itemId"),
      action: ""
    };
    // Check if editing inline
    if (this.props.listIndex !== undefined) {
      opts.index = this.props.listIndex;
    }
    this.props.setItemAction(opts);
  }

  render() {
    // Get the transfer item and ref item
    let transferItem = this.props.transferItem;
    let product = this.props.product;

    // Handle to prop values
    let action = dot(transferItem,"action");

    let name = dot(product,"data.name");
    let price = parseFloat(dot(transferItem,"data.unitCost")) || 0;
    let quantity = parseFloat(dot(transferItem,"data.quantity")) || 0;
    let comment = dot(transferItem,"data.comment");

    // Get the product name
    let type = dot(transferItem,"data.item.type") || dot(product,"data.type");
    let productName = dot(transferItem,"data.item.name") || dot(product,"data.name");

    let control = null;
    if (action == "delete") {
      control = <ActionVal className="Control" onClick={(evt)=>{this.onUndoClick(evt)}}>&#8635;</ActionVal>
    } else {
      control = <ActionVal theme="red" className="Control" onClick={(evt)=>{this.onDeleteClick(evt)}}>&#x2715;</ActionVal>
    }

    return (
      <div className="Form TransferItemForm" ref="root" data-action={action}>
        <Readout className="Name" label={capitalize(type)} onClick={(e,h)=>{this.onProductClick(e,h)}}>{productName}</Readout>
        <Input className="Quantity" label="Quantity" type="number" value={quantity} onChange={(val)=>{this.editField("quantity",parseFloat(val))}}/>
        {control}
      </div>
    );
  }
}

const mapState = (state, props) => {
  let itemId = dot(props.transferItem,"data.itemId");
  let product = itemId ? (dot(state.inventory,["products",itemId]) || {}) : {};
  return {
    inventory: state.inventory,
    product: product
  }
};

const mapDispatch = (dispatch) => {
  return {
    setItemField: opts => dispatch(setItemField(opts)),
    listItems: opts => dispatch(listItems(opts)),
    setItemAction: opts => dispatch(setItemAction(opts))
  }
};

export default connect(
  mapState,
  mapDispatch
)(TransferItemForm)
